import React from "react";
import { Container, Typography, Paper, Box } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Link } from "react-router-dom";
import PageIntro from "../components/pageintro";
import ServicesGridCards from "../components/servicesgrid";
import WhyTecloqCards from "../components/whytecloqcards";
import TransformComponent from "../components/transformcomp";
import GridCards from "../components/oddservicegrids";

const transformdata = {
    heading:"Take the next step with Tecloq",
    content:"Discover the true power of product development with Tecloq’s cutting-edge React services. Elevate your digital presence and user experience through our expertise and innovation, driving your brand towards unparalleled success.",
}

const whyData = [
  {
    src: "/assets/ProductEngineering/Python/why1.png",
    alt: "why1",
    title: "Cutting-Edge Technology Stack",
    description:
      "We stay at the forefront of technology trends. Leveraging the latest Python technologies, frameworks, and libraries, we craft solutions that are not only efficient and scalable but also future-ready.",
  },
  {
    src: "/assets/ProductEngineering/Python/why2.png",
    alt: "why1",
    title: "Data-Driven Insights",
    description:
      "With expertise in Python, data science and analytics, we go beyond development. We empower you with data-driven insights, helping you make informed decisions and maximize the impact of your Python-powered solutions.",
  },
  {
    src: "/assets/ProductEngineering/Python/why3.png",
    alt: "why1",
    title: "Client-Centric Approach",
    description:
      "Your satisfaction is our priority. We adopt a client-centric approach, involving you in every step of the development process. We value your input, feedback, and vision, ensuring the end result aligns perfectly with your objectives.",
  },
];

const offeringdata = [
  {
    src: "/assets/ProductEngineering/Python/pds1.png",
    alt: "text analysis",
    width: "65%",
    paddingTop: "5%",
    text: "Prototyping & MVP\nDevelopment",
  },
  {
    src: "/assets/ProductEngineering/Python/pds2.png",
    alt: "text analysis",
    width: "70%",
    paddingTop: "0%", // No padding specified
    text: "AI & ML Solution",
  },
  {
    src: "/assets/ProductEngineering/Python/pds3.png",
    alt: "text analysis",
    width: "65%",
    paddingTop: "1%",
    text: "Python Custom Web\nDevelopment service",
  },
  {
    src: "/assets/ProductEngineering/Python/pds4.png",
    alt: "text analysis",
    width: "58%",
    paddingTop: "8%",
    text: "Api Development &\nIntegration",
  },
];

const pythonDevelopmentData = [
  {
    src: "/assets/ProductEngineering/Python/pds1.png",
    alt: "Prototyping & MVP Development",
    title: "Prototyping & MVP Development",
    imgWidth: "65%",
    paddingTop: "5%",
  },
  {
    src: "/assets/ProductEngineering/Python/pds2.png",
    alt: "AI & ML Solution",
    title: "AI & ML Solution",
    imgWidth: "70%",
    paddingTop: "0%",
  },
  {
    src: "/assets/ProductEngineering/Python/pds3.png",
    alt: "Python Custom Web Development service",
    title: "Python Custom Web Development service",
    imgWidth: "65%",
    paddingTop: "1%",
  },
  {
    src: "/assets/ProductEngineering/Python/pds4.png",
    alt: "Api Development & Integration",
    title: "Api Development & Integration",
    imgWidth: "58%",
    paddingTop: "8%",
  },
];


const PythonPage = () => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", overflow: "hidden" }}>
      <PageIntro
        bg={"/assets/ProductEngineering/Python/background.webp"}
        subheading={
          "Powering the Next Generation of Web Applications with tecloq"
        }
        heading={"Python Development Services"}
        desc={'"Scalable and efficient Python development."'}
      />

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          margin: { xs: "4%", md: "5%" },
          justifyContent: "center",
          alignContent: "center",
          gap: "10px",
        }}
      >
        <Typography
          sx={{
            fontFamily: "Orbitron",
            fontWeight: "800",
            fontSize: { xs: "24px", md: "40px" }, // Adjust font size for mobile
            color: "#000000",
            lineHeight: "120%",
            letterSpacing: "2%",
            display: "flex",
            justifyContent: "center",
            paddingBottom: "1%",
            textAlign: "center",
          }}
        >
          The Python Development Company That Delivers Results
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" }, // Stack on mobile, row on larger screens
            margin: { xs: "2%", md: "2%" },
            gap: { xs: "14px", md: "45px" }, // Adjust gap for better spacing on mobile
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              fontFamily: "Inter",
              fontSize: { xs: "14px", md: "25px" }, // Smaller font size for mobile
              textAlign: { xs: "center", md: "left" }, // Center align on mobile
            }}
          >
            Tecloq is a trusted and performance-driven Python development
            company that specializes in building scalable and reliable web
            applications, software products, and solutions. We have a team of
            experienced and skilled Python developers who can help you with all
            aspects of your Python development project, from design and
            development to deployment and maintenance. We use cutting-edge
            Python frameworks such as Flask, Web2py, and Django to build
            high-quality, scalable, and secure Python applications. We also
            follow an outcome-driven methodology to ensure that our projects are
            completed on time and within budget. If you are looking for a
            reliable and experienced Python development company, Tecloq is the
            right choice for you.
          </Typography>
          <Box
            component="img"
            src="/assets/ProductEngineering/Python/pdev.png"
            alt="Python Development"
            sx={{
              width: { xs: "80%", sm: "60%", md: "40%" }, // Responsive width based on screen size
              height: "auto", // Maintain aspect ratio
              maxWidth: "100%", // Ensure it doesn't exceed container width
            }}
          />
        </Box>
      </Box>

      <Box
        sx={{
          maxWidth: "100% !important",
          height: "auto",
          margin: { xs: "4% 4% 0 4%", md: "8% 8% 0 8%" }, // Adjust margin for mobile and desktop
        }}
      >
        <Typography
          sx={{
            fontFamily: "Orbitron",
            fontWeight: "800",
            fontSize: { xs: "24px", md: "40px" }, // Smaller font size on mobile
            color: "#000000",
            lineHeight: "120%",
            letterSpacing: "2%",
            display: "flex",
            justifyContent: "center",
            paddingBottom: { xs: "2%", md: "3%" }, // Adjust padding for mobile and desktop
            textAlign: "center", // Ensure text alignment is consistent
          }}
        >
          Our Python Development Services
        </Typography>
      </Box>

      {/* <ServicesGridCards data={offeringdata} /> */}
      <GridCards data={pythonDevelopmentData} cardWidth={"300px"} />

      {/* <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
          "& > :not(style)": {
            m: 1,
            width: 300,
            height: 240,
          },
          gap: "20px",
        }}
      >
        <Paper
          elevation={3}
          sx={{
            borderRadius: "5%",
            textAlign: "center",
            paddingTop: "3%",
            marginBottom: "3%",
          }}
        >
          <img
            src="/assets/ProductEngineering/Python/pds1.png"
            alt="text analysis"
            style={{ boxSizing: "border-box", width: "65%", height: "auto" }}
          ></img>
          <Typography
            style={{
              fontFamily: "Inter",
              fontStyle: "normal",
              fontWeight: "700",
              fontSize: "16px",
              lineHeight: "21px",
              alignItems: "center",
              textAlign: "center",
              color: "#000000",
              paddingTop: "5%",
            }}
          >
            Prototyping & MVP
            <br />
            Development
          </Typography>
        </Paper>
        <Paper
          elevation={3}
          sx={{
            borderRadius: "5%",
            textAlign: "center",
            paddingBottom: "3%",
            alignContent: "center",
          }}
        >
          <img
            src="/assets/ProductEngineering/Python/pds2.png"
            alt="text analysis"
            style={{ boxSizing: "border-box", width: "70%", height: "auto" }}
          ></img>
          <Typography
            style={{
              fontFamily: "Inter",
              fontStyle: "normal",
              fontWeight: "700",
              fontSize: "16px",
              lineHeight: "21px",
              alignItems: "center",
              textAlign: "center",
              color: "#000000",
            }}
          >
            AI & ML Solution
          </Typography>
        </Paper>
        <Paper
          elevation={3}
          sx={{
            borderRadius: "5%",
            textAlign: "center",
            paddingBottom: "3%",
            alignContent: "center",
          }}
        >
          <img
            src="/assets/ProductEngineering/Python/pds3.png"
            alt="text analysis"
            style={{
              boxSizing: "border-box",
              width: "65%",
              height: "auto",
              paddingTop: "1%",
            }}
          ></img>
          <Typography
            style={{
              fontFamily: "Inter",
              fontStyle: "normal",
              fontWeight: "700",
              fontSize: "16px",
              lineHeight: "21px",
              alignItems: "center",
              textAlign: "center",
              color: "#000000",
              paddingTop: "5%",
            }}
          >
            Python Custom Web
            <br />
            Development service
          </Typography>
        </Paper>
        <Paper
          elevation={3}
          sx={{
            borderRadius: "5%",
            textAlign: "center",
            paddingBottom: "3%",
            alignContent: "center",
          }}
        >
          <img
            src="/assets/ProductEngineering/Python/pds4.png"
            alt="text analysis"
            style={{
              boxSizing: "border-box",
              width: "58%",
              height: "auto",
              paddingTop: "8%",
            }}
          ></img>
          <Typography
            style={{
              fontFamily: "Inter",
              fontStyle: "normal",
              fontWeight: "700",
              fontSize: "16px",
              lineHeight: "21px",
              alignItems: "center",
              textAlign: "center",
              color: "#000000",
              paddingTop: "5%",
            }}
          >
            Api Development &<br />
            Integration
          </Typography>
        </Paper>
      </Box> */}

      <Box
        sx={{
          maxWidth: "100%",
          height: "auto",
          marginTop: { xs: "6%", md: "3%" }, // Increased top margin for better spacing on mobile
          paddingX: { xs: "5%", md: "0" }, // Add horizontal padding on smaller screens
        }}
      >
        <Typography
          sx={{
            fontFamily: "Orbitron",
            fontWeight: "800",
            fontSize: { xs: "24px", md: "40px" }, // Smaller font size for mobile
            color: "#000000",
            lineHeight: "120%",
            letterSpacing: "2%",
            display: "flex",
            justifyContent: "center",
            paddingBottom: "1%",
            textAlign: "center",
          }}
        >
          Python Frameworks we Work With
        </Typography>
        <Typography
          sx={{
            fontFamily: "Inter",
            fontWeight: "lighter",
            fontSize: { xs: "14px", md: "20px" }, // Adjust font size for mobile
            color: "#000000",
            display: "flex",
            justifyContent: "center",
            margin: { xs: "3% 5%", md: "1% 10% 0%" }, // Adjust margins for better spacing
            textAlign: "center",
          }}
        >
          Python’s versatility and extensive library support make it an ideal
          choice for web development. We’re a trusted Django development company
          and Flask web development expert. Our expertise in these Python
          frameworks, combined with our commitment to quality and innovation,
          ensures your web applications exceed expectations.
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
          gap: "1%",
        }}
      >
        {[
          {
            title: "Django",
            description: `Django, often called the "batteries included" framework, is a top
              choice for complex web applications. We specialize in Django
              development services and leverage its strengths to streamline
              Python application development. With its DRY and MVT architecture
              patterns, Django reduces development time, allowing us to focus on
              creating exceptional features aligned with your business goals.`,
          },
          {
            title: "Flask",
            description: `Flask, a Python-based microframework, is known for its simplicity
              and flexibility. As a Flask web development company, we use
              Flask's capabilities to seamlessly add unique elements to your web
              applications. With built-in server and debugger support, Flask
              simplifies the development process. We craft tailored web
              solutions that precisely meet your requirements.`,
          },
        ].map((item, index) => (
          <Paper
            key={index}
            elevation={3}
            sx={{
              width: { xs: "90%", md: 600 },
              padding: "2%",
              boxShadow: "none",
              display: "flex",
              alignItems: "flex-start",
              gap: "16px",
            }}
          >
            <img
              src="/assets/BigData/DataLake/charm_circle-tick.png"
              alt={`why${index + 1}`}
              style={{
                width: "10%",
                height: "10%",
                verticalAlign: "bottom",
              }}
            />
            <Box>
              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontWeight: "bold",
                  fontSize: { xs: "18px", md: "20px" },
                  lineHeight: "120%",
                  color: "#000",
                }}
              >
                {item.title}
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontWeight: "normal",
                  fontSize: { xs: "14px", md: "16px" },
                  lineHeight: "140%",
                  color: "#000",
                  paddingTop: "3%",
                  textAlign: "left",
                }}
              >
                {item.description}
              </Typography>
            </Box>
          </Paper>
        ))}
      </Box>

      <Box
        sx={{
          maxWidth: "100%",
          height: "auto",
          marginTop: { xs: "10%", md: "6%" }, // Adjusted top margin for better spacing on mobile
          paddingX: { xs: "5%", md: "0" }, // Added horizontal padding on small screens
        }}
      >
        <Typography
          sx={{
            fontFamily: "Orbitron",
            fontWeight: "800",
            fontSize: { xs: "28px", md: "40px" }, // Adjust font size for mobile and desktop
            color: "#000000",
            lineHeight: "120%",
            letterSpacing: "2%",
            display: "flex",
            justifyContent: "center",
            paddingBottom: "3%",
            textAlign: "center",
          }}
        >
          The Teloq Advantage
        </Typography>
        <Typography
          sx={{
            fontFamily: "Inter",
            fontWeight: "100",
            fontSize: { xs: "14px", md: "20px" }, // Adjust font size for readability on smaller screens
            color: "#000000",
            lineHeight: "120%",
            letterSpacing: "2%",
            display: "flex",
            justifyContent: "center",
            paddingBottom: "3%",
            margin: { xs: "0 5%", md: "0 15%" }, // Adjust margins for better text wrapping
            textAlign: "center",
          }}
        >
          We bring a unique blend of expertise, innovation, and commitment to
          every Python development project. Discover how our Python software
          development services stand out, making us the preferred Python
          development company. Join hands with us and experience the difference
          that expertise, innovation, and commitment can make in your Python
          development journey.
        </Typography>
      </Box>

      <WhyTecloqCards data={whyData} />

      <TransformComponent data={transformdata}/>

      
    </Box>
  );
};
export default PythonPage;
